import { handleActions } from 'redux-actions';
import AudioActions from 'app/actions/audio/audioAction.ts';

export interface IAudioState {
  voice: string;
}

const initialState: IAudioState = {
  voice: ''
};

export const audioReducer = handleActions<IAudioState, boolean | { count: number } | any>(
  {
    [AudioActions.Type.SET_AUDIO_STORE]: (state, action): IAudioState => {
      return { ...state, voice: action.payload as string };
    }
  },
  initialState
);
